import { render, staticRenderFns } from "./FerryForm.vue?vue&type=template&id=50bfec04"
import script from "./FerryForm.vue?vue&type=script&lang=ts"
export * from "./FerryForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports